import { buildElement } from '../../../utils/element'
import { SellingPlanGroup } from '../../../models/selling-plan-group'
import { getBuyOnceAsSellingPlanGroup, isBuyOnceId, shouldShowBuyOnce } from '../../../models/buy-once'
import { widgetState } from '../../../store/customizations/index'
import { getLowestDiscountByGroupForVariant, getSellingPlanAllocationForVariant } from '../../../models/selling-plan-allocation'
import { getSelectedSellingPlanGroupId, getSelectedSellingPlanId, getSellingPlanGroups } from '../../../store/selling-plans/getters'
import { getWithCurrencySymbol } from '../../../models/price-format'

const wrapperElementClass = 'yotpo-subscription-price-label-wrapper'

export const buildPriceLabel = (group: SellingPlanGroup, isSubscription: boolean, isSelected: boolean): HTMLElement => {
  const wrapperElement = buildElement('div', wrapperElementClass, {})
  const containerElement = buildElement('div', 'yotpo-subscription-price-label-container', {})

  if (isSubscription && shouldShowPrefix(isSelected)) {
    const pricePrefixElement = buildElement('div', 'yotpo-subscription-label-prefix', {})
    pricePrefixElement.textContent = widgetState.customizations.priceLabel.prefix
    wrapperElement.appendChild(pricePrefixElement)
  }

  const priceElement = buildElement('div', 'yotpo-subscription-label-price', {})

  const price = getPrice(group, isSelected)
  const priceFormat = widgetState.customizations.fullFormatProductPrice
  const fullPriceWithCurrency = getWithCurrencySymbol(priceFormat, price)

  priceElement.textContent = fullPriceWithCurrency
  containerElement.appendChild(priceElement)

  wrapperElement.appendChild(containerElement)

  return wrapperElement
}

export const replacePriceElement = () => {
  const groups = getSellingPlanGroups()

  if (shouldShowBuyOnce()) {
    groups.push(getBuyOnceAsSellingPlanGroup())
  }

  groups.forEach(group => {
    const priceWrapElement = document.querySelector(`[data-seling-plan-group-id="${group.id}"] .${wrapperElementClass}`)

    if (priceWrapElement) {
      const newPriceElement = buildPriceLabel(
        group,
        !isBuyOnceId(group.id),
        group.id === getSelectedSellingPlanGroupId()
      )
      priceWrapElement.replaceWith(newPriceElement)
    }
  })
}

const shouldShowPrefix = (isSelected: boolean): boolean => {
  if (widgetState.customizations.priceLabel.strategy === 'starting_from') {
    return true
  }
  if (widgetState.customizations.priceLabel.strategy === 'starting_and_actual') {
    return !isSelected
  }
  return false
}

const getPrice = (group: SellingPlanGroup, isSelected: boolean): number => {
  if (widgetState.customizations.priceLabel.strategy === 'starting_and_actual' && isSelected) {
    return getSelectedPriceForGroup(group)
  }
  return getLowestDiscountByGroupForVariant(group.id)
}

const getSelectedPriceForGroup = (group: SellingPlanGroup): number => {
  const sellingPlans = group.sellingPlans
  const plan = sellingPlans.find(plan => {
    if (!plan.id) {
      return false
    }
    return plan.id.toString() === getSelectedSellingPlanId()
  })
  if (!plan) {
    return getLowestDiscountByGroupForVariant(group.id)
  }
  return getSellingPlanAllocationForVariant(group.id, plan.id)
}
